"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const faInfoCircle_1 = require("@fortawesome/pro-regular-svg-icons/faInfoCircle");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const cosmos_1 = require("components/cosmos");
const Html_1 = __importDefault(require("components/Html"));
const useLegacyClubRedirect_1 = __importDefault(require("components/legacyClubRedirectAlert/useLegacyClubRedirect"));
const useNewClubMigrationModal_1 = __importDefault(require("components/newClubMigrationModal/useNewClubMigrationModal"));
const translate_1 = require("components/translate");
const Settings_1 = __importDefault(require("configs/Settings"));
const withFeatureToggle_1 = require("hoc/withFeatureToggle");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const services_1 = require("modules/app/services");
const clubMigrationCta_1 = require("modules/app/services/datahubEvents/hotmartClub/clubMigrationCta");
const auth_1 = require("modules/auth");
const featureToggle_1 = require("modules/featureToggle");
require("./newClubMigrationAlert.scss");
const NewClubMigrationAlert = ({ productId, t }) => {
    const { hasNewClub } = (0, useLegacyClubRedirect_1.default)(String(productId));
    const { isAccessPlus } = (0, useNewClubMigrationModal_1.default)(productId);
    const isOwner = auth_1.AuthService.isOwner();
    if (hasNewClub || isAccessPlus || !isOwner) {
        return null;
    }
    function handleSendEvent() {
        const schema = new clubMigrationCta_1.ClickMigrationNewClub({
            componentName: services_1.ComponentNames.BUTTON_NEW_CLUB_MIGRATION_ALERT,
            productId: String(productId)
        });
        services_1.DatahubEventsService.sendEvent({
            schema
        });
    }
    const params = new URLSearchParams({
        oldClubMigration: 'true',
        productId: String(productId),
        oldClubUrl: window.location.href
    });
    const url = `${Settings_1.default.app.bw}/membership/list?${params.toString()}`;
    return ((0, jsx_runtime_1.jsxs)(cosmos_1.Alert, { className: "new-club-migration-alert d_block _d-md-flex _justify-content-between\n     _position-sticky _bg-yellow _mb-0 _justify-content-start _align-items-center _rounded-0 _px-md-7", children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faInfoCircle_1.faInfoCircle }), (0, jsx_runtime_1.jsx)(Html_1.default, { tag: "p", className: "_my-0 _mx-4 _text-2", children: t('cta_new_club_migration.alert.text_v2') })] }), (0, jsx_runtime_1.jsx)("a", { href: url, onClick: handleSendEvent, target: "_self", rel: "noopener noreferrer", className: "hot-button _bg-yellow _border-gray-900 _text-gray-900\n        _ml-6 _ml-md-0 _px-2 _py-1 _mt-2 _text-2 _text-decoration-none", children: t('cta_new_club_migration.modal.button_v1') })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(({ MembershipStore }) => ({
    productId: MembershipStore.productId
})))((0, withFeatureToggle_1.withFeatureToggle)(NewClubMigrationAlert, featureToggle_1.FeatureToggles.EnableNewClubMigrationCTA));
